export default __webpack_public_path__ + "static/media/Care11.a6d99f43.png";